import React from "react";
import style from "./Modalities.module.scss";
import { signedLockedAccess } from "../../../../utils";
import { Button, Form, MultiSelect } from "../../../primary";
import { CANCEL_BTN, SAVE_BTN } from "../../../../constants";

export const MultiSelectSectionEditMode = ({
  label,
  fieldId,
  assessmentDetails,
  setFormChangesConfirm,
  handleSubmit,
  doSubmit,
  listResp,
  sectionData,
  listViewRef,
  register,
  onSelectChange,
  onCancelClick,
  hideButtons,
}) => (
  <div className="mt-3 pt-1">
    {signedLockedAccess(assessmentDetails?.assessmentStage) ? (
      <Form setFormChangesConfirm={setFormChangesConfirm} formChanges={true} onSubmit={handleSubmit(doSubmit)}>
        <MultiSelect
          id={fieldId}
          name={fieldId}
          label={label}
          classes={{
            column: ` row ${style.botton_spac}`,
            inputClassName: `${style.basic_select}`,
            labelClassName: `col-4 col-form-label ${style.label_spec}`,
            inputColumn: "col-6 p-0",
          }}
          optionValue={Array.isArray(listResp) ? listResp : []}
          showCheckbox={true}
          displayValue="value"
          validator={(e) => {
            register({ required: true });
            listViewRef.current = e;
          }}
          onSelect={onSelectChange}
          onRemove={onSelectChange}
          defaultValue={sectionData ?? []}
          labelSubText="Select all that apply"
        />

        {hideButtons && (
          <div className="row">
            <div className="mt-4 pt-2 col-sm-12 p-0">
              <div className="offset-4">
                <Button type="submit" classes={{ className: `btn ${style.btn_save}` }} id="updateBtn" value={SAVE_BTN} />
                <Button classes={{ className: `btn ${style.btn_cancel}` }} type="button" id="cancel" value={CANCEL_BTN} onClick={onCancelClick} />
              </div>
            </div>
          </div>
        )}
      </Form>
    ) : (
      "This wound assessment is signed and locked, cannot be updated."
    )}
  </div>
);
